import React from "react";
import TitlePage from "../../../app/Title/TitlePage";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Dialog} from "primereact/dialog";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Divider} from "@material-ui/core";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {
    capacityMultipliedOneHundred, capacityMultipliedOneHundredTemplate
} from "../../../utils/formatters/Numbers";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import NumberFormat from "react-number-format";
import {Checkbox} from "primereact/checkbox";
import PropTypes from 'prop-types';

const CapacityTableView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Control de Límite \ Tabla de Aforos"/>
                    </Grid>
                    <Grid item xs={6}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Editar Aforo Mínimo"
                                    className="p-button-secondary"
                                    onClick={props.openDialogMinimumCapacity}
                                    disabled={props.isClosed}
                            />&nbsp; &nbsp;
                            <Button label="Buscar"
                                onClick={props.getDataCapacityTable}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid p-align-center p-justify-end">
                            <div className="p-col-12 p-md-6 p-lg-6" >
                                <SubtitleLabel header={"Aforo Mínimo:"} isBold={true}/>
                                {capacityMultipliedOneHundred(props.minimumCapacity,"left", "%")}
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <Button type="button"
                                        iconPos="left"
                                        label="Borrar excepciones"
                                        style={{'float': 'right'}}
                                        onClick={props.openConfMsg}
                                        className="p-button-secondary"
                                        disabled={props.isClosed}
                                /> &nbsp; &nbsp;
                                <Button type="button"
                                        iconPos="left"
                                        label="Agregar excepción"
                                        style={{'float': 'right'}}
                                        onClick={props.openDialogAddException}
                                        className="p-button-secondary"
                                        disabled={props.isClosed}
                                />
                            </div>
                        </div>

                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.dataCapacityTable}
                            onSelectionChange={props.handleSelectedRows}
                            selection={props.selectedRows}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column selectionMode="multiple" style={{width: '5%', textAlign: 'center'}}/>
                            <Column field="borrowerShortName" header="Institución"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="minimumCapacity" header="Aforo para la Institución"
                                    style={{textAlign: 'left'}}
                                    body={capacityMultipliedOneHundredTemplate}
                                    sortable={true}/>
                            <Column header="Acciones"
                                    style={{textAlign: 'center', width: '8em'}}
                                    body={props.capacityTableActionTemplate}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog visible={props.displayDialog}
                    header={props.dialogHeader}
                    modal={true}
                    onHide={props.onHideDialog}
                    closable={false}
                    contentStyle={{overflow:'visible'}}
                    style={{width: "45%",}}>

                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-12 p-lg-3" hidden={props.isEditMinimumCapacity}>
                        <SubtitleLabel header="Institución Actual" isBold={true}/>
                        <SubtitleLabel header={props.changeData.lenderShortName}/>
                    </div>
                    <div className="p-col-12 p-md-12 p-lg-4" hidden={props.isEditMinimumCapacity}>
                        <SubtitleLabel header="Institución para Operar" isBold={true}/>
                        <SubtitleLabel header={props.changeData.borrowerShortName} hidden={props.isAddException}/>
                        <div hidden={props.isEditException}>
                            <Dropdown placeholder="Seleccione..."
                                      name="borrower"
                                      filter={true}
                                      required={true}
                                      filterBy="shortName"
                                      optionLabel="shortName"
                                      onChange={props.onChangeDrop}
                                      value={props.changeData.borrower}
                                      options={props.borrowerInstitutions}
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-12 p-lg-2">
                        <SubtitleLabel header="%Aforo" isBold={true}/>
                        <NumberFormat name="percentageCapacity"
                                      thousandSeparator={true}
                                      allowNegative={false}
                                      maxLength={7}
                                      required={true}
                                      decimalScale={4}
                                      placeholder="Ex: 11.110"
                                      customInput={InputText}
                                      onChange={props.onChangeInputText}
                                      value={props.changeData.percentageCapacity}/>
                    </div>
                    <div className="p-col-12 p-md-12 p-lg-3" hidden={!props.isEditMinimumCapacity}>
                        <SubtitleLabel header="Borrar Excepciones" isBold={true}/>
                        <Checkbox
                            name="deleteExceptions"
                            checked={props.changeData.deleteExceptions}
                            onChange={props.onChangeCheckBox}/>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={props.displayInfoDialog}
                    header={<div className="p-grid p-fluid">
                        <div className="p-col-10" style={{padding: '.1em'}}>
                            <h2 className={"secondary-text"}>Información</h2>
                        </div>
                        <div className="p-col-2" style={{padding: '.2em'}}>
                            <Button label="Aceptar"
                                    onClick={props.onHideInfoDialog}/>
                        </div>
                    </div>}
                    modal={true}
                    onHide={props.onHideInfoDialog}
                    closable={false}
                    contentStyle={{overflow: 'visible'}}
                    style={{width: "45%",}}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 ">
                        <SubtitleLabel header="No se puede editar el Aforo Mínimo durante el horario operativo." />
                    </div>
                </div>
            </Dialog>
            {props.confirmationMessage}
        </React.Fragment>
    )
};

CapacityTableView.propTypes = {
    isClosed: PropTypes.bool.isRequired,
    onHideInfoDialog: PropTypes.func.isRequired,
    displayInfoDialog: PropTypes.func.isRequired
}

export default CapacityTableView;